
import { ShortcutActionType } from "../action-types/shorcutTypes"
import { Action } from "../actions/shortcutActions"

const initialState: string[] = []

const reducer = (state: string[] = initialState, action: Action) => {
    switch (action.type) {
        case ShortcutActionType.LIST:
            return action.payload
        case ShortcutActionType.ADD:
            return [...state, action.payload]
        case ShortcutActionType.REMOVE:
            return state.filter(st => st !== action.payload)
        default:
            return state
    }
}

export default reducer